import { render, staticRenderFns } from "./FoodAssistanceApplications.vue?vue&type=template&id=15467a69&"
import script from "./FoodAssistanceApplications.vue?vue&type=script&lang=js&"
export * from "./FoodAssistanceApplications.vue?vue&type=script&lang=js&"
import style0 from "./FoodAssistanceApplications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports